<script setup>
import { reactive, ref, onMounted, defineEmits, watch, inject } from 'vue';
import countryListData from '@/utils/country.js';
import CountryFlag from 'vue-country-flag-next'
import { showMessage } from "@/utils/hooks/message"
import { database_template_name_v3, company_type_list } from "@/service/index"
// import { AreaJson } from "@/utils/china.js"
import i18n from "@/i18n"
import { getLangValue, getLangValueByKey, switch_company_type_list_to_language_config } from "@/utils/common"; //获取后端语言
const isCheckForm = ref(false)
const formData = reactive({
    companyNmae: '',
    companyType: [],
    name: '',
    xing: '',
    email: '',
    phone: '',
    phoneCountry: '',
    phoneCountryKey: '',
    phone_number: '',
    phone_numberCountry: '',
    phone_numberCountryKey: '',
    main_business_areas: [],
    // testing_company: '',
    // is_certification_company: '',
})
const contact_address = ref([
    {
        country: '',
        countryKey: '',
        province: '',
        city: '',
        address: '',
        post: '',
    }
])
const countryList = ref(countryListData);
const countryList1 = ref(countryListData);
// const cityList = ref([])
// const oldCityList = ref([])
// const provinceList = ref([])
const emits = defineEmits(['nextStep'])
const detailInfo = inject('detailInfo')
const companyTypeList = ref([])
const filterCountry = (query) => {
    if (query) {
        countryList.value = countryList1.value.filter((item) => {
            if ((item.zh.toLowerCase()).includes(query.toLowerCase()) || (item.en.toLowerCase()).includes(query.toLowerCase())) {
                return true
            }
        })
    } else {
        countryList.value = [...countryList1.value] //val为空时，还原数组
    }
}
const main_business_areas_list = ref([])
const checkForm = () => {
    //验证表单信息
    isCheckForm.value = true;
    let checkRes = true
    for (const item in formData) {
        if (item == 'main_business_areas' || item == 'companyType') {
            if (formData[item].length == 0 || formData[item] == null) {
                checkRes = false
                // console.log(111);
                break;
            }
        } else if (item == 'testing_company') {
            if (formData[item] === '') {
                checkRes = false
                break;
            }
        } else if (item == 'is_certification_company') {
            if (formData[item] === '') {
                checkRes = false
                break;
            }
        }
        else {
            if (!formData[item]) {
                checkRes = false
                break;
            }
        }
    }
    return checkRes;
}

// const checkContactAddress = () => {
//     // check地址
//     let checkRes = true
//     for (const item in contact_address.value) {
//         if (!contact_address.value[item].countryKey ||
//             !contact_address.value[item].province ||
//             !contact_address.value[item].city ||
//             !contact_address.value[item].address ||
//             !contact_address.value[item].post) {
//             checkRes = false
//             break;
//         }
//     }
//     return checkRes;
// }
const checkEmail = () => {
    if (formData.email) {
        // 邮箱格式
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(formData.email)) {
            return false;
        }
    }
    return true;
}

const changephoneCountry = (type = 0, country) => {
    if (type == 0) {
        formData.phoneCountryKey = ''
        if (formData.phoneCountry) {
            let arr = countryListData.filter((item) => item.zh === formData.phoneCountry || item.en === formData.phoneCountry)
            if (arr.length > 0) {
                formData.phoneCountryKey = arr[0].key
            }
        }
    } else if (type == 1) {
        formData.phone_numberCountryKey = ''
        if (formData.phone_numberCountry) {
            let arr = countryListData.filter((item) => item.zh === formData.phone_numberCountry || item.en === formData.phone_numberCountry)
            if (arr.length > 0) {
                formData.phone_numberCountryKey = arr[0].key
            }
        }
    } else {
        if (country) {
            let arr = countryListData.filter((item) => item.zh === country || item.en === formData.country )
            if (arr.length > 0) {
                return arr[0].key
            }
        }
    }
}

// const changeProvince = (key) => {
//     cityList.value[key] = []
//     // console.log(contact_address.value[key].province);
//     if (contact_address.value[key].province) {
//         let arr = AreaJson.filter(item => item.name === contact_address.value[key].province)
//         // console.log(arr);
//         if (arr.length) {
//             // 直辖市
//             if (arr[0].city[0].name === contact_address.value[key].province) {
//                 // 获取区
//                 cityList.value[key] = arr[0].city[0].area.map(item => { return { name: item } })
//                 oldCityList.value[key] = [...cityList.value[key]]
//             } else {
//                 cityList.value[key] = arr[0].city.map(item => { return { name: item.name } })
//                 oldCityList.value[key] = [...cityList.value[key]]
//             }
//             // console.log(cityList.value[key]);
//         }
//     }
// }

const getTemplateList = async () => {
    // let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    // if (data.length > 0) {
    //     main_business_areas_list.value = data;
    // } else {
    let params = {
        status: 1,
    }
    const reps = await database_template_name_v3(params)
    if (reps) {
        if (reps.payload.length == 0) {
            main_business_areas_list.value = [{ name: getLangValueByKey('base.none'), name_en: getLangValueByKey('base.none', 'en'), role_key: '无', }]
        } else {
            main_business_areas_list.value = reps.payload;
        }
    }
    // }
}

const getCompany_type_list = async () => {
    const reps = await company_type_list()
    if (reps.code == 0) {
        companyTypeList.value =  switch_company_type_list_to_language_config(reps.payload)
    }
}
const next = () => {
    let res = checkForm()
    if (!res) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }
    let checkEmailRes = checkEmail()
    if (!checkEmailRes) {
        showMessage('danger', getLangValue('login.message10'))
        return false
    }
    // let checkAddress = checkContactAddress()
    // if (!checkAddress) {
    //     showMessage('danger', i18n.global.t('base.requiredinformation'))
    //     return false
    // }

    // 暂存信息 以及跳转到下一步
    emits('nextStep', [formData, contact_address.value])
}

const getCountryBykey = (countryKey) => {
    if (countryKey) {
        let arr = countryListData.filter(item => item.zh === countryKey || item.en === countryKey)
        if (arr.length > 0) {
            return arr[0].key
        }
    }
    return ''
}




// const changeCountry = (key) => {
//     // 选择国家 展示对应的key
//     if (!contact_address.value[key].country) {
//         contact_address.value[key].countryKey = ''
//     } else {
//         let arr = countryList.value.filter(item => item.zh === contact_address.value[key].country)
//         if (arr.length > 0) {
//             contact_address.value[key].countryKey = arr[0].key
//         }
//     }
//     // 如果是中国
//     if (contact_address.value[key].countryKey == 'CN') {
//         provinceList.value[key] = [...AreaJson]
//     }
// }


onMounted(() => {
    getTemplateList();
    getCompany_type_list();
    // let key = changephoneCountry(2, '中国')
    // console.log(key);
})



watch(detailInfo, (val) => {
    // 显示数据
    console.log(val);
    formData.companyNmae = val.company_name
    formData.companyType = val.company_type ? val.company_type.split(',') : []
    formData.name = val.contact_last_name
    formData.xing = val.contact_first_name
    // formData.name = val.contact_name
    formData.email = val.contact_email
    formData.phone = val.landline_number
    formData.phoneCountry = val.landline_number_area
    formData.phoneCountryKey = getCountryBykey(val.landline_number_area)
    formData.phone_number = val.mobile_phone_number
    formData.phone_numberCountry = val.mobile_phone_number_area
    formData.phone_numberCountryKey = getCountryBykey(val.mobile_phone_number_area)
    formData.main_business_areas = val.business_scope ? val.business_scope : [];
    formData.is_certification_company = val.certification_company
    formData.testing_company = val.testing_company
    // console.log(formData.main_business_areas);
    // 显示联系人地址
    // contact_address.value = val.contact_address.map((item) => {
    //     return {
    //         id: item.id,
    //         country: item.name,
    //         countryKey: item.country,
    //         province: item.province,
    //         city: item.city,
    //         address: item.address1,
    //         post: item.postcode,
    //     }
    // })
    // if (contact_address.value.length) {
    //     contact_address.value.forEach((item, key) => {
    //         if (item.countryKey == 'CN') {
    //             changeCountry(key)
    //             changeProvince(key)
    //         }
    //     })
    // }
})
</script>
<template>
    <form class="mt-5">
        <div class="row  d-flex justify-content-center my-form" style="width: 820px; margin:  0 auto;">
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','form_companyName') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <input :class="[(isCheckForm && !formData.companyNmae) && 'is-invalid']"
                        v-model="formData.companyNmae" :placeholder=" getLangValue('my.account','form_companyName_placeholder')"
                        class="form-control" style="display: inline;" />
                </div>
            </div>

            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','form_contacts') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <input :class="[(isCheckForm && !formData.name) && 'is-invalid']" v-model="formData.name"
                        :placeholder=" getLangValue('my.account','form_contacts_name')" class="form-control"
                        style="display: inline; margin-right: 0.5rem;" />
                    <input :class="[(isCheckForm && !formData.xing) && 'is-invalid']" v-model="formData.xing"
                        :placeholder=" getLangValue('my.account','form_contacts_xing')" class="form-control" style="display: inline;" />
                </div>
            </div>
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','form_email') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <input :class="[(isCheckForm && !formData.email) && 'is-invalid']" placeholder=""
                        class="form-control" style="display: inline; " v-model="formData.email" />
                </div>
            </div>
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','form_phone') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <div class="input-group  d-flex align-items-center">
                        <div class="input-group-text p-0" style="width: 220px;"
                            :class="[(isCheckForm && !formData.phoneCountry) && 'is-invalid1']">
                            <el-select :class="[(isCheckForm && !formData.phoneCountry) && 'is-invalid1']"
                                v-model="formData.phoneCountry" filterable placeholder=" " size="large"
                                @change="changephoneCountry(0)" style="width: 100%;" clearable
                                :filter-method="filterCountry">
                                <template #prefix>
                                    <!-- 将前置插槽数据设置为label的值 -->
                                    <country-flag :country='formData.phoneCountryKey' size='small' />
                                </template>
                                <el-option v-for="item1 in countryList" :key="item1.key" :label=" i18n.global.locale == 'en' ? item1.en: item1.zh"
                                    :value=" i18n.global.locale == 'en' ? item1.en: item1.zh">
                                    <country-flag :country='item1.key' size='small' /> {{ i18n.global.locale == 'en' ? item1.en:  item1.zh }}
                                </el-option>
                            </el-select>
                        </div>
                        <input clearable class="form-control flex-1" v-model="formData.phone" style="height: 42px;"
                            :class="[(isCheckForm && !formData.phone) && 'is-invalid']" />
                    </div>
                </div>
            </div>
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','form_phone_number') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <div class="input-group  d-flex align-items-center">
                        <div class="input-group-text p-0" style="width: 220px;"
                            :class="[(isCheckForm && !formData.phone_numberCountry) && 'is-invalid1']">
                            <el-select :class="[(isCheckForm && !formData.phone_numberCountry) && 'is-invalid1']"
                                @change="changephoneCountry(1)" v-model="formData.phone_numberCountry" filterable
                                placeholder=" " size="large" style="width: 100%;" clearable
                                :filter-method="filterCountry">
                                <template #prefix>
                                    <!-- 将前置插槽数据设置为label的值 -->
                                    <country-flag :country='formData.phone_numberCountryKey' size='small' />
                                </template>
                                <el-option v-for="item1 in countryList" :key="item1.key" :label="i18n.global.locale == 'en' ? item1.en: item1.zh"
                                    :value="i18n.global.locale == 'en' ? item1.en: item1.zh">
                                    <country-flag :country='item1.key' size='small' /> {{ i18n.global.locale == 'en' ? item1.en: item1.zh }}
                                </el-option>
                            </el-select>
                        </div>
                        <input clearable class="form-control flex-1" v-model="formData.phone_number"
                            style="height: 42px;" :class="[(isCheckForm && !formData.phone_number) && 'is-invalid']" />
                    </div>
                </div>
            </div>
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','form_Enterprisetype') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <el-select collapse-tags collapse-tags-tooltip :max-collapse-tags="1"
                        :class="[(isCheckForm && (formData.companyType == null || formData.companyType.length == 0)) && 'is-invalid']"
                        filterable multiple v-model="formData.companyType"
                        :placeholder=" getLangValue('my.account','form_Enterprisetype_placeholder')" size="large" style="width: 100%;"
                        clearable>
                        <!-- <el-option label="供应商" value="供应商" />
                        <el-option label="制造商" value="制造商" />
                        <el-option label="采购商" value="采购商" />
                        <el-option label="品牌商" value="品牌商" />
                        <el-option label="分销商" value="分销商" />
                        <el-option label="零售商" value="零售商" />
                        <el-option label="服务提供商" value="服务提供商" />
                        <el-option label="检测机构" value="检测机构" />
                        <el-option label="认证机构" value="认证机构" /> -->
                        <el-option v-for="(item, key) in companyTypeList" :key="key" :label="item.name"
                            :value="item.id" />
                    </el-select>
                </div>
            </div>
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','form_main_business_areas') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <el-select collapse-tags collapse-tags-tooltip :max-collapse-tags="3"
                        :class="[(isCheckForm && (formData.main_business_areas == null || !formData.main_business_areas.length)) && 'is-invalid']"
                        v-model="formData.main_business_areas" filterable multiple
                        :placeholder=" getLangValue('my.account','form_main_business_areas_placeholder')" size="large"
                        style="width: 100%;" clearable>
                        <el-option v-for="(item, key) in main_business_areas_list" :key="key" :label=" i18n.global.locale == 'en' ? item.name_en : item.name"
                            :value="item.role_key" />
                    </el-select>
                </div>
            </div>
            <!-- <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','from_is_check_company') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <el-select :class="[(isCheckForm && formData.testing_company === '') && 'is-invalid']"
                        v-model="formData.testing_company"
                        :placeholder=" getLangValue('my.account','from_is_check_company_placeholder')" size="large" style="width: 100%;"
                        clearable>
                        <el-option label="是" :value="true" />
                        <el-option label="否" :value="false" />
                    </el-select>
                </div>
            </div>
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{  getLangValue('my.account','from_is_certification_company') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <el-select :class="[(isCheckForm && formData.is_certification_company === '') && 'is-invalid']"
                        v-model="formData.is_certification_company"
                        :placeholder=" getLangValue('my.account','from_is_certification_company_placeholder')" size="large"
                        style="width: 100%;" clearable>
                        <el-option label="是" :value="true" />
                        <el-option label="否" :value="false" />
                    </el-select>
                </div>
            </div> -->
            <div class="col-100 my-3">
                <div class="d-flex align-items-center justify-content-center">
                    <b-button variant="success" @click="next" style="width: 104px;">
                        {{ getLangValue('login.next') }}
                    </b-button>
                </div>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
.my-form {
    :deep(.el-select__placeholder) {
        color: #888a98 !important;
        font-size: 13px !important;
    }

    :deep(.input-group-text .el-select__wrapper) {
        // border-radius: 0px 0.25rem 0.25rem 0;
        box-shadow: unset !important;
    }

    .is-invalid {
        border: 1px solid #f06548;
        border-radius: 4px;
    }

    .is-invalid1 {
        border: 1px solid #f06548;
        border-right: unset !important;
        // border-radius: 4px;
    }

    .input-group-text.is-invalid1 {
        border: unset !important;
    }

    .form-label {
        text-align: right;
        width: 220px !important;
    }

    .form-control {
        color: #888a97;
    }
}
</style>